import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { i18nIntl, importCSS } from '../../lib/ep.js';
import { size as _size } from 'lodash';
import { sweep as const_sweep } from './bootstrap';

import { SquaredButton } from '../builder/ActionButton';
import ButtonCollection from '../builder/ButtonCollection.js';
import FloatingLayer from '../builder/FloatingLayer';
import Input from '../builder/Input';
import SaveButton from '../builder/SaveButton';
import SectionTitle from '../builder/SectionTitle';

class SweepPostSelected extends Component {
	constructor(props,context) {

		const object_post = {};
		object_post['post_id'] = props.post_id
		if(props.page)object_post['page'] = props.page
		if(props.creator)object_post['creator'] = props.creator

		super(props, context);
		this.state = {
			post:object_post,
			display_edit_ads:false
		}
	}

	componentWillMount() {
		importCSS('comp/sweeps.css');
	}

	goto(link){
		if(this.props.is_linked){
			window.open(link, '_blank');
		}else{
			return false;
		}
	}

	togglePost() {
		this.state.display_edit_ads = !this.state.display_edit_ads;
		this.setState({...this.state});
	}

	changeProfile(k, v) {
		this.state.post['page'][k] = v;
		this.setState({...this.state});
	}

	render() {
		const i18n = (m, c) => i18nIntl(m, this.props.intl, c);

		const post = this.state.post;

		const is_placeholder = (this.props.placeholder != undefined) ? this.props.placeholder : false;
		if(is_placeholder) {
			return (
				<div class="is_placeholder">
					<div class="gui_single_post">
						<div class="gui_post_media"></div>

						<div class="gui_post_contents">
							<div class="text_contents">
								<h5>Fake title text for preview</h5>
								<p>This is a fake description short text for preview purposes</p>
							</div>
						</div>
					</div>
				</div>
			)
		}

		const icon_class = (this.props.type!=undefined && this.props.type == const_sweep.TYPE_LEAD_ADS) ? 'ep-'+const_sweep.ID_FACEBOOK : 'ep-'+this.props.network;
		const has_media = (this.props.media != '' && this.props.media!=undefined) ? true : false;
		const has_description = (this.props.description != '') ? true : false;
		const option_delete = (this.props.delete != undefined) ? this.props.delete : true;
		const network = (this.props.network != undefined) ? this.props.network : true;

		const is_linked = (this.props.is_linked != undefined) ? this.props.is_linked : false;
		const is_editable = (this.props.is_ads && this.props.network == const_sweep.ID_INSTAGRAM && this.props.status && this.props.type!='create') ? true : false;
		const brand = (post.page != undefined && post.page.name != undefined) ? post.page.name : ((post.creator != undefined) ? post.creator : i18n("Item"))
		return (
			<div>
				{(this.props.page != undefined || this.props.is_ads != undefined) && (
					<div class="gui_ribbons">
						{this.props.page != undefined && (
							<span class={"with_icon "+icon_class}>
								{brand}
							</span>
						)}
						{this.props.is_ads != undefined && (
							<span class={"ribon is_dark"}>{i18n("Promoted")}</span>
						)}
						{this.props.colaborator != undefined && (
							<span class={"ribon yellowBg"}>{i18n("Collaborator")}</span>
						)}
					</div>
				)}
				<div class={"gui_single_post" + (is_linked ? ' linked' : '')} onClick={(link) => this.goto(this.props.link)}>
					{has_media && (
						<div class="gui_post_media" style={{backgroundImage:"url("+this.props.media+")"}}></div>
					)}
					<div class="gui_post_contents">
						<div class="text_contents">
							<h5>{this.props.text}</h5>
							{has_description && (
								<p>{this.props.description}</p>
							)}
						</div>
					</div>
				</div>
				{(option_delete) && (
					<SquaredButton
						onClick={() => this.props.onClick()}
						color='red'
						icon='knk-off'
						_class={{ other:'remove_post' }}
						aria-label="Delete"
					/>
				)}
				{(is_editable) && (
					<SquaredButton
						onClick={() => this.togglePost()}
						icon='knk-edit'
						_class={{ other:'remove_post' }}
						aria-label="Edit"
					/>
				)}

				{(this.state.display_edit_ads) && (
					<FloatingLayer backButton={() => this.togglePost()} _class={{size:'small'}}>
						<div class="gui_flexbox_auto gui_flex_col gui_flex_nowrap">
							<SectionTitle>Change profile of promoted post</SectionTitle>

							<Input
								name="name"
								model={this.state.post.page}
								change={(k, v) => this.changeProfile(k, v)}
								_class={{first:true}}
								max_length="20"
							>Name</Input>
							
							<ButtonCollection _class={{other:'not_in_top gui_flex_end'}}>
								<SaveButton
									disabled={_size(this.state.post.page.name) < 3}
									onClick={(post, cb) => this.props.onChange(this.state.post,this.togglePost())}
									color='green'
								>Save</SaveButton>
							</ButtonCollection>
						</div>
					</FloatingLayer>
				)}
			</div>
		);
	}
}

export default injectIntl(SweepPostSelected);